export class Qualtrics {
  e: any;
  h: any;
  f: any;
  g: any;
  constructor(e: any, h: any, f: any, g: any) {
    this.e = e;
    this.h = h;
    this.f = f;
    this.g = g;
  }
  get(a: any): any {
    for (var z = a + '=', c = document.cookie.split(';'), b = 0, e = c.length; b < e; b++) {
      for (var d = c[b]; ' ' == d.charAt(0); ) d = d.substring(1, d.length);
      if (0 == d.indexOf(z)) return d.substring(z.length, d.length);
    }
    return null;
  }

  set = function (a: any, c: any) {
    var b: any = new Date();
    b.setTime(b.getTime() + 6048e5);
    b = '; expires=' + b.toGMTString();
    document.cookie = a + '=' + c + b + '; path=/; ';
  };

  check() {
    var a = this.get(this.f);
    if (a) a = a.split(':');
    else if (100 != this.e) {
      // eslint-disable-next-line
      'v' == this.h && (this.e = Math.random() >= this.e / 100 ? 0 : 100),
        (a = [this.h, this.e, 0]),
        this.set(this.f, a.join(':'));
    } else return !0;
    var c = a[1];
    if (100 == c) return !0;
    switch (a[0]) {
      case 'v':
        return !1;
      case 'r':
        return (c = a[2] % Math.floor(100 / c)), a[2]++, this.set(this.f, a.join(':')), !c;
    }
    return !0;
  }

  go() {
    if (this.check()) {
      var a: any = document.createElement('script');
      a.type = 'text/javascript';
      a.src = this.g;
      document.body && document.body.appendChild(a);
    }
  }

  start() {
    var t = this;
    'complete' !== document.readyState
      ? window.addEventListener
        ? window.addEventListener(
            'load',
            function () {
              t.go();
            },
            !1,
          )
        : (<any>window).attachEvent &&
          (<any>window).attachEvent('onload', function () {
            t.go();
          })
      : t.go();
  }
}
